import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Button } from "primereact/button";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CloseIcon from "@mui/icons-material/Close";
import MenuItem from "@mui/material/MenuItem";
import axios from "axios";
import { Dialog } from "primereact/dialog";
import Select from "@mui/material/Select";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import FicheLogTerminal from "./journal";
import { TextField, TextareaAutosize } from "@mui/material";
import { fr } from "date-fns/locale";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import formatToISODate from "../formatDateISO";
import { Calendar } from "primereact/calendar";
import DevisDialog from "./DevisDialog";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";

import convertTimeStringToDate from "../timeToDate";
const apiUrl = process.env.REACT_APP_API_URL;

export default function SuivisFiches() {
const [editMode, setEditMode] = useState(false);
const [loading, setLoading] = useState(true);


const [ficheLeadsSuivis, setFicheLeadsSuivis] = useState([]);

const [copiedText, setCopiedText] = useState("");
const [openSnackbar, setOpenSnackbar] = useState(false);

const [openSnackbarMail, setOpenSnackbarMail] = useState(false);
const [snackbarMessage, setSnackbarMessage] = useState("");

const [visible, setVisible] = useState(false);

const [rechercheSuivis, setRechercheSuivis] = useState("");

  const [tempIdFicheLead, setTempIdFicheLead] = useState("");
  const [tempNom, setTempNom] = useState("");
  const [tempEmail, setTempEmail] = useState("");
  const [tempTel, setTempTel] = useState("");
  const [tempLieu, setTempLieu] = useState("");
  const [tempNbpers, setTempNbpers] = useState("");
  const [tempHeuredebut, setTempHeuredebut] = useState("");
  const [tempTypeBar, setTempTypeBar] = useState("");
  const [tempBarman, setTempBarman] = useState("");
const [tempMore, setTempMore] = useState("");
  const [nbAppels, setNbAppels] = useState("");

const [ficheListeFiltre, setFicheListeFiltre] = useState("");
const [note, setNote] = useState("");

const [appel, setAppel] = useState("");
const [date, setDate] = useState(null);

const [dateValidation, setDateValidation] = useState(null);
const [dateDevis,setDateDevis] = useState(null);

const [tempStatus, setTempStatus] = useState("");

const [heureDem, setHeureDem] = useState("");


const [devisDialogVisible, setDevisDialogVisible] = useState(false);
const [currentLeadForDevis, setCurrentLeadForDevis] = useState(null);


const openDevisDialog = (leadData) => {
  setCurrentLeadForDevis({
    idLead: leadData.idLead,
    nomPrenom: leadData.nomPrenom,
    email: leadData.email,
    tel: leadData.tel,
    lieu: leadData.lieu,
    nbpers: leadData.nbpers
  });
  setDevisDialogVisible(true);
};

const handleDevisGenerated = () => {
  axios
    .get(`${apiUrl}/IHM/api/lead.php?ficheLeadSuivis`)
    .then((response) => {
      setFicheLeadsSuivis(response.data);
    })
    .catch((error) => {
      console.error("Erreur lors du rechargement :", error);
    });
};



const getLabel = () => {
    switch (appel) {
      case "0":
        return "Nouvelle";
      case "1":
        return "En cours";
      case "2":
        return "Suivis";
      case "3":
        return "Validés";
      case "4":
        return "Réalisés";
        case "5":
        return "Abandons";
      default:
        return "inconnus";
    }
  };

 const copyToClipboard = (text) => {
    if (text !== "") {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            setCopiedText(text);
            setOpenSnackbar(true);
          })
          .catch((error) => {
            console.error(
              "Erreur lors de la copie dans le presse-papiers : ",
              error
            );
          });
      } else {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);

        setCopiedText(text);
        setOpenSnackbar(true);
      }
    }
  };


   const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };
  const handleCloseSnackbarMail = () => {
    setOpenSnackbarMail(false);
  };


useEffect(() => {
    axios
      .get(`${apiUrl}/IHM/api/lead.php?ficheLeadSuivis`)
      .then((response) => {
        setFicheLeadsSuivis(response.data);
      })
      .catch((error) => {
        console.error("Erreur lors du chargement des factures :", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);


  useEffect(() => {
      const recherche = rechercheSuivis.toLowerCase();
      const filteredList = ficheLeadsSuivis.filter((fiche) => {
        const nomPrenom = fiche.nomPrenom?.toLowerCase() || "";
        const tel = fiche.tel?.toLowerCase() || "";
        const lieu = fiche.lieu?.toLowerCase() || "";
        const email = fiche.email?.toLowerCase() || "";
        return (
          nomPrenom.includes(recherche) ||
          tel.includes(recherche) ||
          lieu.includes(recherche) ||
          email.includes(recherche)
        );
      });
      setFicheListeFiltre(filteredList);
    }, [rechercheSuivis, ficheLeadsSuivis]);

const enteteTableauNouvelle = () => {
    return (
      <div className="flex justify-content-end">
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search" />
          <InputText
            value={rechercheSuivis}
            onChange={(e) => setRechercheSuivis(e.target.value)}
            placeholder="Rechercher"
          />
        </IconField>
        <Button
          icon="pi pi-plus"
          size="small"
          severity="success"
          aria-label="Ajouter"
          onClick={() => window.open("https://tally.so/r/b5La7e", "_blank")}
          style={{
            width: 20,
            height: 20,
            padding: 0,
            fontSize: "14px",
          }}
        />
      </div>
    );
  };

     const setInfoClick = (idFicheleads, nom, tel, email, lieu, nbpers,) => {
    setAppel("");
    setNote("");
    setDate("");

    setTempNom(nom);
    setTempTel(tel);
    setTempEmail(email);
    setTempLieu(lieu);
    setTempNbpers(nbpers);
    setTempIdFicheLead(idFicheleads);

    setHeureDem(null);

    axios
      .get(`${apiUrl}IHM/api/lead.php?idLead=${idFicheleads}`)
      .then((response) => {
        setTempStatus(response.data[0].status);
        setTempHeuredebut(response.data[0].heuredebut);
        setTempTypeBar(response.data[0].type_bar);
        setTempBarman(response.data[0].barman);
        setTempMore(response.data[0].more);
        
        setAppel(response.data[0].etat);
        setNbAppels(response.data[0].nbappels);

        setVisible(true);
      })
      .catch((error) => {
        console.error(
          "Une erreur s'est produite lors de la récupération de la fiche :",
          error
        );
      });
  };


  const handleSavePhoneCall = async () => {
    if (!dateValidation && appel === "3") {
      alert("La date de validation est obligatoire");
      return;
    } else if (!dateDevis && appel === "2") {
      alert("La date de  devis est obligatoire");
      return;
    }

    let data = {
      idLead: tempIdFicheLead,
      etat: appel,
      note: note,
      adminMod: localStorage.getItem("us"),
    };

    if (dateValidation && appel === "3") {
      const isoDate = formatToISODate(dateValidation);
      data.dateValidation = isoDate;
    }

    if (dateDevis && appel == "2") {
      const isoDate = formatToISODate(dateDevis);
      data.dateDevis = isoDate;
    }

    try {
      let response;

      response = await axios.put(`${apiUrl}IHM/api/lead.php`, data);
      if (response.data) {
        setVisible(false);
        window.location.reload();
      } else {
        setVisible(false);
        window.location.reload();
      }
    } catch (error) {
      console.error(
        "Erreur lors de la sauvegarde de l'appel téléphonique",
        error,
      );
    }
  };


    const handleValidate = async () => {
      try {
        await axios.post(`${apiUrl}IHM/api/update_ficheLead.php`, {
          idLead: tempIdFicheLead,
          nom: tempNom,
          telephone: tempTel,
          email: tempEmail,
          lieu: tempLieu,
          nbpers: tempNbpers,
        });
        setEditMode(false);
      } catch (error) {
        console.error("Erreur de mise à jour :", error);
        alert("Erreur lors de la sauvegarde");
      } finally {
      }
    };
  
    const header = (
      <div className="flex justify-between items-center w-full">
        <span className="font-semibold text-lg mr-2">Leads</span>
        <div className="flex items-center gap-2">
          <span style={{ cursor: "pointer" }}>
            {editMode ? (
              <>
                <span
                  onClick={() => handleValidate()}
                  style={{
                    border: "1px solid #22c55e",
                    borderRadius: "50%",
                    color: "#fff",
                    width: "28px",
                    height: "28px",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    marginRight: "8px",
                    transition: "all 0.2s ease",
  
                    backgroundColor: "#22c55e",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#22c55e";
                    e.currentTarget.style.color = "#fff";
                  }}
                >
                  <CheckIcon sx={{ fontSize: 16 }} />
                </span>
  
                <span
                  onClick={() => setEditMode(false)}
                  style={{
                    border: "1px solid #ef4444",
                    borderRadius: "50%",
                    color: "#ffffffff",
                    width: "28px",
                    height: "28px",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    backgroundColor: "#ef4444",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#ef4444";
                    e.currentTarget.style.color = "#fff";
                  }}
                >
                  <CloseIcon sx={{ fontSize: 16 }} />
                </span>
              </>
            ) : (
              <span
                style={{
                  border: "1px solid #4b5563",
                  borderRadius: "50%",
                  color: "#ffffffff",
                  width: "28px",
                  height: "28px",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  marginRight: "8px",
                  transition: "all 0.2s ease",
                  backgroundColor: "#4b5563",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#4b5563";
                  e.currentTarget.style.color = "#fff";
                }}
                onClick={() => setEditMode(true)}
              >
                {" "}
                <EditIcon sx={{ fontSize: 16 }} />{" "}
              </span>
            )}
          </span>
        </div>
      </div>
    );
  

      return (
        <>
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            open={openSnackbarMail}
            autoHideDuration={1000}
            onClose={handleCloseSnackbarMail}
            message={snackbarMessage}
            action={
              <React.Fragment>
                <IconButton
                  size="small"
                  aria-label="close"
                  color="inherit"
                  onClick={handleCloseSnackbarMail}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </React.Fragment>
            }
          />

          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            open={openSnackbar}
            autoHideDuration={1000}
            onClose={handleCloseSnackbar}
            message={`Copie réussie de " ${
              copiedText === "location.mail" ? "e-mail" : copiedText
            } "`}
            action={
              <React.Fragment>
                <IconButton
                  size="small"
                  aria-label="close"
                  color="inherit"
                  onClick={handleCloseSnackbar}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </React.Fragment>
            }
          />

          <Dialog
            blockScroll
            visible={visible}
            header={header}
            className="custom-dialog"
            style={{ width: "40vw" }}
            modal
            onHide={() => {
              setVisible(false);
              setEditMode(false);
            }}
            breakpoints={{ "960px": "100vw", "640px": "100vw" }}
          >
            <div className="p-3">
              <div className="grid">
                {/* Etat actuel */}
                <div className="col-12 md:col-6">
                  <div className="p-2 px-0 surface-100 border-round-sm flex justify-between align-items-left">
                    <span className="font-bold">État actuel :</span>
                    <span
                      className="p-1 px-2 text-sm"
                      style={{ background: "#e5e7eb", borderRadius: "5px" }}
                    >
                      {tempStatus}
                      <small>
                        <small>({nbAppels})</small>
                      </small>
                    </span>
                  </div>
                </div>

                {/* Etat souhaité */}
                <div className="col-12 md:col-6">
                  <div className="p-2 px-0 surface-100 border-round-sm flex justify-between align-items-left">
                    <span className="font-bold">État souhaité :</span>
                    <Select
                      labelId="etat-label"
                      id="etat-select"
                      value={appel}
                      onChange={(e) => setAppel(e.target.value)}
                      displayEmpty
                      style={{
                        minWidth: "130px",
                        maxWidth: "130px",
                        maxHeight: "20px",
                      }}
                      MenuProps={{
                        container: document.body,
                        style: { zIndex: 9999 },
                      }}
                    >
                      <MenuItem value="" disabled>
                        Séléctionner un état
                      </MenuItem>
                      <MenuItem value="1">En cours</MenuItem>
                      <MenuItem value="2">Suivis</MenuItem>
                      <MenuItem value="3">Validés</MenuItem>
                      <MenuItem value="4">Réalisés</MenuItem>
                      <MenuItem value="5">Abandons</MenuItem>
                    </Select>
                  </div>
                </div>
              </div>
              {/* Ligne 1 */}
              <div className="grid">
                <div className="col-12 md:col-6">
                  <div
                    className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                    style={{ background: "#f9fafb", borderRadius: "5px" }}
                  >
                    <span className="font-bold">Nom :</span>

                    {editMode ? (
                      <InputText
                        value={tempNom}
                        onChange={(e) => setTempNom(e.target.value)}
                        style={{ height: "10px" }}
                      />
                    ) : (
                      <span
                        onClick={() => copyToClipboard(tempNom)}
                        className="cursor-pointer"
                      >
                        {tempNom} <ContentCopyIcon sx={{ fontSize: 12 }} />
                      </span>
                    )}
                  </div>
                </div>

                <div className="col-12 md:col-6">
                  <div
                    className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                    style={{ background: "#f9fafb", borderRadius: "5px" }}
                  >
                    <span className="font-bold">Email :</span>

                    {editMode ? (
                      <InputText
                        value={tempEmail}
                        onChange={(e) => setTempEmail(e.target.value)}
                        style={{ height: "10px" }}
                      />
                    ) : (
                      <span
                        onClick={() => copyToClipboard(tempEmail)}
                        className="cursor-pointer"
                      >
                        {tempEmail} <ContentCopyIcon sx={{ fontSize: 12 }} />
                      </span>
                    )}
                  </div>
                </div>
              </div>

              {/* Ligne 2 */}
              <div className="grid">
                <div className="col-12 md:col-6">
                  <div
                    className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                    style={{ background: "#f9fafb", borderRadius: "5px" }}
                  >
                    <span className="font-bold">Téléphone :</span>

                    {editMode ? (
                      <InputText
                        value={tempTel}
                        onChange={(e) => setTempTel(e.target.value)}
                        style={{ height: "10px" }}
                      />
                    ) : (
                      <span
                        onClick={() => copyToClipboard(tempTel)}
                        className="cursor-pointer"
                      >
                        {tempTel} <ContentCopyIcon sx={{ fontSize: 12 }} />
                      </span>
                    )}
                  </div>
                </div>

                <div className="col-12 md:col-6">
                  <div
                    className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                    style={{ background: "#f9fafb", borderRadius: "5px" }}
                  >
                    <span className="font-bold">Lieu :</span>

                    {editMode ? (
                      <InputText
                        value={tempLieu}
                        onChange={(e) => setTempLieu(e.target.value)}
                        style={{ height: "10px" }}
                      />
                    ) : (
                      <span
                        onClick={() => copyToClipboard(tempLieu)}
                        className="cursor-pointer"
                      >
                        {tempLieu} <ContentCopyIcon sx={{ fontSize: 12 }} />
                      </span>
                    )}
                  </div>
                </div>
              </div>

              {/* Ligne 3 */}
              <div className="grid">
                <div className="col-12 md:col-6">
                  <div
                    className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                    style={{ background: "#f9fafb", borderRadius: "5px" }}
                  >
                    <span className="font-bold">Nb pers :</span>
                    {editMode ? (
                      <InputText
                        value={tempNbpers}
                        onChange={(e) => setTempNbpers(e.target.value)}
                        style={{ height: "10px" }}
                      />
                    ) : (
                      <span
                        onClick={() => copyToClipboard(tempNbpers)}
                        className="cursor-pointer"
                      >
                        {tempNbpers} <ContentCopyIcon sx={{ fontSize: 12 }} />
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-12 md:col-6">
                  <div
                    className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                    style={{ background: "#f9fafb", borderRadius: "5px" }}
                  >
                    <span className="font-bold">Heure de Début :</span>
                    {editMode ? (
                      <InputText
                        value={tempHeuredebut}
                        onChange={(e) => setTempHeuredebut(e.target.value)}
                        style={{ height: "10px" }}
                      />
                    ) : (
                      <span
                        onClick={() => copyToClipboard(tempHeuredebut)}
                        className="cursor-pointer"
                      >
                        {tempHeuredebut}{" "}
                        <ContentCopyIcon sx={{ fontSize: 12 }} />
                      </span>
                    )}
                  </div>
                </div>
              </div>

              {/* Ligne 4 */}

              <div className="grid">
                <div className="col-12 md:col-6">
                  <div
                    className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                    style={{ background: "#f9fafb", borderRadius: "5px" }}
                  >
                    <span className="font-bold">Type de Bar :</span>
                    {editMode ? (
                      <InputText
                        value={tempTypeBar}
                        onChange={(e) => setTempTypeBar(e.target.value)}
                        style={{ height: "10px" }}
                      />
                    ) : (
                      <span
                        onClick={() => copyToClipboard(tempTypeBar)}
                        className="cursor-pointer"
                      >
                        {tempTypeBar} <ContentCopyIcon sx={{ fontSize: 12 }} />
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-12 md:col-6">
                  <div
                    className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                    style={{ background: "#f9fafb", borderRadius: "5px" }}
                  >
                    <span className="font-bold">Barman :</span>
                    {editMode ? (
                      <InputText
                        value={tempBarman}
                        onChange={(e) => setTempHeuredebut(e.target.value)}
                        style={{ height: "10px" }}
                      />
                    ) : (
                      <span
                        onClick={() => copyToClipboard(tempBarman)}
                        className="cursor-pointer"
                      >
                        {tempBarman} <ContentCopyIcon sx={{ fontSize: 12 }} />
                      </span>
                    )}
                  </div>
                </div>
              </div>
              {/* Ligne 5 */}
              <div className="grid">
                <div className="col-12 md:col-6">
                  <div
                    className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                    style={{ background: "#f9fafb", borderRadius: "5px" }}
                  >
                    <span className="font-bold">Plus d'infos :</span>
                    {editMode ? (
                      <InputText
                        value={tempMore}
                        onChange={(e) => setTempMore(e.target.value)}
                        style={{ height: "10px" }}
                      />
                    ) : (
                      <span
                        onClick={() => copyToClipboard(tempMore)}
                        className="cursor-pointer"
                      >
                        {tempMore} <ContentCopyIcon sx={{ fontSize: 12 }} />
                      </span>
                    )}
                  </div>
                </div>
              </div>

              {appel === "2" && (
                <div className="grid">
                  <div className="col-12 md:col-12">
                    <div className="p-2 px-0 border-round-sm surface-100 flex flex-column gap-2 px-0">
                      <span className="font-bold">Date d'envoi du devis</span>
                      <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        adapterLocale={fr}
                      >
                        <DatePicker
                          value={dateDevis}
                          onChange={(newValue) => setDateDevis(newValue)}
                          renderInput={(props) => (
                            <TextField {...props} fullWidth />
                          )}
                          inputFormat="dd/MM/yyyy"
                          minDate={new Date()}
                          PopperProps={{
                            container: document.body,
                            placement: "bottom-start",
                            modifiers: [
                              {
                                name: "preventOverflow",
                                options: {
                                  boundary: "viewport",
                                },
                              },
                            ],
                          }}
                        />
                      </LocalizationProvider>
                    </div>
                  </div>
                </div>
              )}

              {appel === "3" && (
                <div className="grid">
                  <div className="col-12 md:col-12">
                    <div className="p-2 px-0 border-round-sm surface-100 flex flex-column gap-2 px-0">
                      <span className="font-bold">Date de validation</span>
                      <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        adapterLocale={fr}
                      >
                        <DatePicker
                          value={dateValidation}
                          onChange={(newValue) => setDateValidation(newValue)}
                          renderInput={(props) => (
                            <TextField {...props} fullWidth />
                          )}
                          inputFormat="dd/MM/yyyy"
                          minDate={new Date()}
                          PopperProps={{
                            container: document.body,
                            placement: "bottom-start",
                            modifiers: [
                              {
                                name: "preventOverflow",
                                options: {
                                  boundary: "viewport",
                                },
                              },
                            ],
                          }}
                        />
                      </LocalizationProvider>
                    </div>
                  </div>
                </div>
              )}

              <div className="grid">
                <div className="col-12 md:col-12">
                  <div className="py-0 px-0 border-round-sm surface-100 flex flex-column">
                    <span className="font-bold">Ajouter une note :</span>
                  </div>
                </div>
              </div>
              <div className="grid">
                <div className="col-12 md:col-12">
                  <TextareaAutosize
                    variant="standard"
                    minRows={5}
                    maxRows={10}
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                    style={{ width: "100%", borderRadius: "5px" }}
                    className="mt-2"
                  />
                </div>
              </div>

              <div className="grid">
                <div className="col-12 md:col-12">
                  <div className="border-round-sm surface-100 flex flex-column"></div>
                  <Button
                    label="Enregistrer l'état et la note"
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#094ed8";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#2563eb";
                    }}
                    className="w-full text-white"
                    style={{
                      background: "#2563eb",
                      border: "1px solid #2563eb",
                      padding: "0.75rem",
                      borderRadius: "5px",
                    }}
                    onClick={() => {
                      if (appel) {
                        handleSavePhoneCall();
                      }
                    }}
                  />
                </div>
              </div>

              <FicheLogTerminal idFicheLeads={tempIdFicheLead} />
            </div>
          </Dialog>
          <DevisDialog
            visible={devisDialogVisible}
            onHide={() => setDevisDialogVisible(false)}
            leadData={currentLeadForDevis}
            onDevisGenerated={handleDevisGenerated}
          />
          <DataTable
            value={ficheListeFiltre}
            paginator
            size="small"
            rows={25}
            header={enteteTableauNouvelle}
            rowsPerPageOptions={[5, 10, 25, 50]}
            tableStyle={{ minWidth: "50rem" }}
            scrollable
            scrollDirection="horizontal"
            paginatorTemplate={
              "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
            }
            paginatorRight={
              <span style={{ margin: "10px", fontWeight: "bold" }}>
                Résultats : {ficheListeFiltre.length}
              </span>
            }
            loading={loading}
            loadingIcon="pi pi-spin pi-spinner"
            emptyMessage={
              loading
                ? "Chargement des nouvelles fiches..."
                : "Aucune fiche pour le moment"
            }
          >
            <Column
              field="dateFicheLead"
              header="Date devis"
              bodyStyle={{ fontSize: "14px" }}
              body={(rowData) => {
                const date = new Date(rowData.dateDevis);
                const day = String(date.getDate()).padStart(2, "0");
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const year = date.getFullYear();
                if (rowData.dateDevis) {
                  return (
                    <span>
                      {day}/{month}/{year}{" "}
                    </span>
                  );
                } else {
                  return <></>;
                }
              }}
            />

            <Column
              field="type"
              header="Type"
              bodyStyle={{ fontSize: "14px" }}
              body={(rowData) => (
                <div>
                  <span
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      copyToClipboard(rowData.vous_etes);
                    }}
                  >
                    {rowData.vous_etes}
                  </span>
                </div>
              )}
            />

            <Column
              field="nom"
              header="Client"
              bodyStyle={{ fontSize: "14px" }}
              body={(rowData) => (
                <div>
                  <span
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      copyToClipboard(rowData.nomPrenom);
                    }}
                  >
                    {rowData.nomPrenom}
                  </span>
                </div>
              )}
            />

            <Column
              field="email"
              header="Email"
              bodyStyle={{ fontSize: "14px" }}
              body={(rowData) => (
                <div>
                  <span
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      copyToClipboard(rowData.email);
                    }}
                  >
                    {rowData.email}
                  </span>
                </div>
              )}
            />

            <Column
              field="tel"
              header="Tél"
              bodyStyle={{ fontSize: "14px" }}
              body={(rowData) => {
                return (
                  <div style={{ cursor: "pointer" }}>
                    <span
                      onClick={() => {
                        copyToClipboard(rowData.tel);
                      }}
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      {rowData.tel}
                    </span>
                  </div>
                );
              }}
            />

            <Column
              field="lieu"
              header="Lieu"
              bodyStyle={{ fontSize: "14px" }}
              body={(rowData) => {
                return (
                  <div style={{ cursor: "pointer" }}>
                    <span
                      onClick={() => {
                        copyToClipboard(rowData.lieu);
                      }}
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      {rowData.lieu}
                    </span>
                  </div>
                );
              }}
            />
            <Column
              field="more"
              header="Note"
              bodyStyle={{ fontSize: "14px" }}
              body={(rowData) => {
                return (
                  <div>
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      {rowData.note}
                    </span>
                  </div>
                );
              }}
            />
            <Column
              header="Actions"
              style={{ textAlign: "center", width: "100px" }}
              body={(rowData) => (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "5px",
                  }}
                >
                  {rowData.a_devis == 1 ? (
                    <>
                      <Button
                        icon="pi pi-download"
                        severity="danger"
                        size="small"
                        tooltip="Télécharger le devis"
                        tooltipOptions={{
                          position: "top",
                          style: { fontSize: "0.7rem" },
                        }}
                        onClick={() => window.open(rowData.lien_pdf, "_blank")}
                      />
                      <Button
                        icon="pi pi-eye"
                        severity="info"
                        size="small"
                        tooltip="Voir"
                        tooltipOptions={{
                          position: "top",
                          style: { fontSize: "0.7rem" },
                        }}
                        onClick={() =>
                          window.open(rowData.lien_devis, "_blank")
                        }
                      />
                      <Button
                        icon="pi pi-pencil"
                        severity="warning"
                        size="small"
                        tooltip="Modifier"
                        tooltipOptions={{
                          position: "top",
                          style: { fontSize: "0.7rem" },
                        }}
                        onClick={() =>
                          window.open(
                            `https://unptittukenplus.vosfactures.fr/invoices/${rowData.idVosFactures}/edit`,
                            "_blank",
                          )
                        }
                      />
                    </>
                  ) : (
                    <Button
                      icon="pi pi-file-pdf"
                      severity="danger"
                      size="small"
                      tooltip="Générer le devis"
                      tooltipOptions={{
                        position: "top",
                        style: { fontSize: "0.7rem" },
                      }}
                      onClick={() => openDevisDialog(rowData)}
                    />
                  )}
                  <Button
                    icon="pi pi-phone"
                    severity="success"
                    size="small"
                    onClick={() => {
                      setInfoClick(
                        rowData.idLead,
                        rowData.nomPrenom,
                        rowData.tel,
                        rowData.email,
                        rowData.lieu,
                        rowData.nbpers,
                      );
                    }}
                  />
                </div>
              )}
            />
          </DataTable>
        </>
      );

}